var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDollhouseCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99945 7.56007L4.7373 4.49049L9.99945 1.4209L15.2616 4.49049L9.99945 7.56007Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99902 13.699V7.55982L4.73688 4.49023V10.6294L9.99902 13.699Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99902 13.699V7.55982L15.2612 4.49023V10.6294L9.99902 13.699Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.95865 11.7793C1.99974 12.317 1.43785 12.9698 1.43785 13.6736C1.43785 15.3643 4.68045 16.7607 8.88002 16.9741M17.0427 11.7793C18.0016 12.317 18.5635 12.9698 18.5635 13.6736C18.5635 15.01 16.5376 16.1625 13.6146 16.6922C13.2269 16.7625 12.8234 16.8218 12.4068 16.8691",
    stroke: "white",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.29883 15.3682L9.58294 16.8859C9.65429 16.9702 9.64376 17.0964 9.55944 17.1678L8.04172 18.4519",
    stroke: "white",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDollhouseCard);
export default __webpack_public_path__ + "static/media/icon-dollhouse-card.eec0cf8d93929d3816c52e3d268fd39b.svg";
export { ForwardRef as ReactComponent };